import React, { useState, useEffect } from 'react'
import { HelpCircle as HelpCircleIcon, Edit3 as EditIcon } from 'react-feather'
import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'
import {
  Container,
  Paper,
  Box,
  CircularProgress,
  Button,
  Tooltip,
  Tabs,
  Tab,
  Typography,
} from '@material-ui/core'

import { FormEdit } from './components/Edit/Form'
import {
  Page,
  ContentHeader,
  MenuButton,
  ConfirmationRiskDialog,
  DriveTour,
  LoadingFeedback,
} from 'components'
import { PaperHeader } from './components/Edit'
import {
  DialogConfirm,
  DeleteDataProcessDialog,
  LegitimateInterest,
  DialogRevertLia,
  DialogManageTag,
} from './components'

import DataProcessProvider from 'providers/DataProcessProvider'

import useAuth from 'hooks/useAuth'
import useSnackbar from 'hooks/useSnackbar'
import useDataProcessOptions from 'hooks/useDataProcessOptions'

import DataProcessTemplateQuestionProvider from 'providers/DataProcessTemplateQuestionProvider'

import helpers from 'helpers'
import { routes } from 'Routes'
import * as service from 'service'
import constants from 'constants/index'
import useStyles from './styles'
import useFetch from 'hooks/useFetch'

const EditPage = ({ match }) => {
  const { dataProcessId } = match.params

  const { statusesCheck } = helpers.dataProcess

  const { REDIRECT_STATUS, PENDING_LIA, DISAPPROVED_LIA } =
    constants.dataProcess

  const history = useHistory()
  const classes = useStyles()
  const snackbar = useSnackbar()
  const { company } = useAuth()

  const [modalConfirmOpen, setModalConfirmOpen] = useState(false)
  const [confirmRiskOpen, setConfirmRiskOpen] = useState(false)
  const [adoptedFragilityId, setAdoptedFragilityId] = useState(null)
  const [loading, setLoading] = useState(false)
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [openTagDialog, setOpenTagDialog] = useState(false)
  const [defaultFragilityId, setDefaultFragilityId] = useState(null)
  const [openTour, setOpenTour] = useState(false)

  const [value, setValue] = useState(0)
  const [dialogRevertLia, setDialogRevertLia] = useState(false)

  const handleChange = (e, newValue) => {
    setValue(newValue)
  }

  const dataProcessOptions = useDataProcessOptions()

  if (!dataProcessOptions.data) {
    dataProcessOptions.loadData(company.id || '')
  }

  const { response, isLoadingStart, refresh } = useFetch(
    service.dponet.dataProcesses.get,
    {
      dataProcessId,
    },
    [dataProcessId, company],
  )

  const dataProcesses = response?.data?.dataProcess

  useEffect(() => {
    if (!isLoadingStart) {
      if (REDIRECT_STATUS.includes(dataProcesses?.statusId))
        history.push(
          reverse(routes.dataProcess.view, { dataProcessId: dataProcessId }),
        )

      if (
        dataProcesses?.statusId === DISAPPROVED_LIA ||
        dataProcesses?.statusId === PENDING_LIA
      )
        setValue(1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response])

  const handleSubmit = () => {
    if (dataProcesses?.acceptProcessFragility) {
      setConfirmRiskOpen(true)
    } else {
      setModalConfirmOpen(true)
    }
  }

  const sendToReview = async () => {
    setLoading(true)
    setModalConfirmOpen(false)
    setConfirmRiskOpen(false)
    try {
      await service.dponet.dataProcesses.changeStatus({
        dataProcessId,
        statusId: constants.dataProcess.WAITING_REVIEW_STATUS,
        adoptedMatrixRiskId: adoptedFragilityId || defaultFragilityId,
      })
      history.push(
        reverse(routes.dataProcess.view, { dataProcessId: dataProcessId }),
      )
      snackbar.open({
        message: 'Processo enviado para a revisão!',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error) ||
          'Ocorreu um erro, tente novamente',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const getBackToList = () => {
    dataProcessOptions.setReload(true)
  }

  const handleOpenTour = () => {
    const where = 'Processos'
    const title = 'Tour'

    const params = {
      action: 'tour-editar-processos',
    }

    helpers.mixpanel.track(where, title, params)
    setOpenTour(true)
  }

  const infoTabs = [
    { label: 'PROCESSO COMPLETO', value: 0 },
    { label: 'LEGÍTIMO INTERESSE (LIA)', value: 1 },
  ]

  const dataProcess = response?.data?.dataProcess
  const data_process_status_id = dataProcesses?.statusId

  const statusPendingLia =
    data_process_status_id === constants.dataProcess.PENDING_LIA

  const statusDisapprovedLia =
    data_process_status_id === constants.dataProcess.DISAPPROVED_LIA

  const showTabLia = statusPendingLia || statusDisapprovedLia

  const enableButton =
    helpers.dataProcess.statusesCheck.isPending(dataProcesses) ||
    helpers.dataProcess.statusesCheck.disapproved(dataProcesses)

  const isPendingLia = statusesCheck.isPendingLia(dataProcess)
  const isReviewLia =
    statusesCheck.isReviewLia(dataProcess) ||
    statusesCheck.isApprovedLia(dataProcess)

  const handleOpenDeleteDialog = () => setOpenDeleteDialog(true)

  const ITEMS = [
    {
      label: 'Classificadores',
      action: () => setOpenTagDialog(true),
      visible: true,
    },
    {
      label: 'Excluir',
      action: () => handleOpenDeleteDialog(),
      visible: enableButton,
    },
    {
      label: 'Reverter LIA',
      action: () => setDialogRevertLia(true),
      visible: isPendingLia || isReviewLia,
    },
  ]

  return (
    <>
      <Page className={classes.root} title="Editar processo">
        <LoadingFeedback open={loading} />
        <Container maxWidth={false} className={classes.container}>
          <Box py={2} mt={1}>
            <ContentHeader title="Processo">
              {enableButton && (
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<EditIcon size={20} />}
                  onClick={handleSubmit}
                  id={constants.dataProcess.DATA_PROCESS_EDIT_DRIVER_STEP_9}
                >
                  Enviar para revisão
                </Button>
              )}
              <Box className={classes.contentHeaderBox}>
                <Tooltip title="Iniciar o tour guiado">
                  <Button
                    id={constants.dataProcess.DATA_PROCESS_MAIN_DRIVER_STEP_1}
                    variant="contained"
                    color="primary"
                    startIcon={<HelpCircleIcon size={20} />}
                    onClick={handleOpenTour}
                    fullWidth
                  >
                    Tutorial
                  </Button>
                </Tooltip>
                {ITEMS.some((item) => item?.visible) && (
                  <MenuButton>
                    {ITEMS.map(
                      (item, index) =>
                        item?.visible && (
                          <Button key={index} onClick={item.action} fullWidth>
                            {item.label}
                          </Button>
                        ),
                    )}
                  </MenuButton>
                )}
              </Box>
            </ContentHeader>
            {showTabLia && (
              <>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  component={Box}
                  mb={3}
                >
                  {infoTabs.map((infoTab) => (
                    <Tab
                      key={infoTab.value}
                      value={infoTab.value}
                      label={infoTab.label}
                      onClick={(e) => handleChange(e, infoTab.value)}
                    />
                  ))}
                </Tabs>
              </>
            )}

            {(value === infoTabs[0].value || !showTabLia) &&
              (isLoadingStart ? (
                <Box
                  id="loadBox"
                  display="flex"
                  width="100%"
                  minHeight="700px"
                  justifyContent="center"
                  alignItems="center"
                >
                  <CircularProgress />
                </Box>
              ) : dataProcesses ? (
                <Paper className={classes.paperMargin}>
                  <PaperHeader
                    data={dataProcesses}
                    isLoading={isLoadingStart}
                  />
                  <DataProcessTemplateQuestionProvider
                    dataProcessTemplate={dataProcessOptions.dataProcessTemplate}
                    step="general_information"
                    dataProcessTemplateAnswers={
                      dataProcesses?.dataProcessTemplateAnswers || []
                    }
                  >
                    <FormEdit
                      dataProcess={dataProcesses}
                      loading={isLoadingStart}
                      refresh={refresh}
                    />
                  </DataProcessTemplateQuestionProvider>
                </Paper>
              ) : (
                <Box
                  display="flex"
                  width="100%"
                  minHeight="400px"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Typography variant="h2" align="center">
                    Não foi possível carregar o processo.
                    <br />
                    Tente novamente mais tarde.
                    <br />
                    Se o erro persistir, abra um chamado para o suporte.
                  </Typography>
                </Box>
              ))}
            {value === infoTabs[1].value && !isLoadingStart && (
              <DataProcessProvider>
                <LegitimateInterest
                  dataProcess={dataProcesses}
                  statusPendingLia={statusPendingLia}
                />
              </DataProcessProvider>
            )}
            {modalConfirmOpen && (
              <DialogConfirm
                title="Enviar processo para a revisão"
                description="Deseja enviar esse processo para revisão?"
                confirmText="Enviar para revisão"
                open={modalConfirmOpen}
                setOpen={setModalConfirmOpen}
                handleConfirm={sendToReview}
              />
            )}
            {confirmRiskOpen && (
              <ConfirmationRiskDialog
                open={confirmRiskOpen}
                setOpen={setConfirmRiskOpen}
                handleConfirm={sendToReview}
                dataProcessId={dataProcessId}
                setAdoptedFragilityId={setAdoptedFragilityId}
                setDefaultFragilityId={setDefaultFragilityId}
              />
            )}
            <DeleteDataProcessDialog
              dataProcessId={dataProcessId}
              open={openDeleteDialog}
              setOpen={setOpenDeleteDialog}
              action={getBackToList}
              redirectTo={routes.dataProcess.all}
            />
            {dialogRevertLia && (
              <DialogRevertLia
                open={dialogRevertLia}
                setOpen={setDialogRevertLia}
                dataProcess={dataProcess}
                setLoading={setLoading}
                refresh={refresh}
              />
            )}
            {openTagDialog && (
              <DialogManageTag
                dataProcessId={dataProcess?.id}
                dataProcessTags={dataProcess?.dataProcessTags}
                setOpen={setOpenTagDialog}
                open={openTagDialog}
                setIsLoading={setLoading}
              />
            )}
            <DriveTour
              stepsMatrix={
                constants.dataProcess.DATA_PROCESS_EDIT_DRIVER_STEPS_OBJECT
              }
              customStyle={classes.customPopover}
              open={openTour}
              setOpen={setOpenTour}
            />
          </Box>
        </Container>
      </Page>
    </>
  )
}

export default EditPage
